var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedicalRecordsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clinical_fe",
    transform: "translate(-6 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M9.333,7.667A1.667,1.667,0,0,1,11,6h4.444a1.667,1.667,0,0,1,1.667,1.667h1.667a1.667,1.667,0,0,1,1.667,1.667v15A1.667,1.667,0,0,1,18.778,26H7.667A1.667,1.667,0,0,1,6,24.333v-15A1.667,1.667,0,0,1,7.667,7.667ZM11,7.111a.556.556,0,0,0-.556.556V8.778A.556.556,0,0,0,11,9.333h4.444A.556.556,0,0,0,16,8.778V7.667a.556.556,0,0,0-.556-.556Zm-.556,5.556v1.667H8.778v1.111h1.667v1.667h1.111V15.444h1.667V14.333H11.556V12.667ZM9.333,18.778a.556.556,0,0,0,0,1.111h7.778a.556.556,0,1,0,0-1.111Zm-.556,3.333a.556.556,0,0,1,.556-.556h7.778a.556.556,0,1,1,0,1.111H9.333A.556.556,0,0,1,8.778,22.111Z",
    fill: "#9c8eeb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    d: "M36,16.667a1.667,1.667,0,0,1,3.333,0v1.667H36Z",
    transform: "translate(-13.333 -4)",
    fill: "#9c8eeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M36,31.333V23h3.333v8.333l-1.667,2.222Z",
    transform: "translate(-13.333 -7.556)",
    fill: "#9c8eeb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalRecordsIcon);
export default __webpack_public_path__ + "static/media/medical-records-icon.cb6d03351d886a65d1ef0806af97d21b.svg";
export { ForwardRef as ReactComponent };